module.exports = __webpack_public_path__ + "a17d279f/img/settings-ico.a214628d.svg";